<template>
    <!-- ラジオボタン風の択一選択 -->
    <div style="display: flex; gap: 18px">
        <button v-for="x in options" :key="x[0]" @click="clicked(x[0])" :disabled="disabled"
            style="display: flex; align-items: center; background: none; border: none; gap: 3px;">

            <div style="width: 14px; height: 14px; border-radius: 50%; border: 1px solid currentColor;">
                <div v-if="value == x[0]" style="width: 100%; height: 100%; border: 1px solid white; border-radius: 50%; background: currentColor"></div>
            </div>
            {{ x[1] }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0,
        },
        options: {
            type: Array,
            default(){
                return []
            },
        },
        unselect: {
            type: Number,
            default: NaN,
        },
        disabled: {
            default: false,
        },
    },
    methods: {
        clicked(key){
            if(this.$props.disabled) return
            let v = Number(key)

            if(this.value == v && !isNaN(this.unselect)){
                this.$emit('input', this.unselect)
            }else{
                this.$emit('input', v)
            }
        },
    },
}
</script>

<style scoped>
button:disabled{
    color: gray;
}
</style>